import React, { useRef } from "react";
import auth from "../auth";
import Version from "version";
import { useConnect } from 'dotnetify';
import { useTranslation } from 'react-i18next';
import PageContainer from '../controls/PageContainer';
import { Grid } from "@material-ui/core";

import ServerState from '../controls/ServerState';
import { Box, BoxTitle, BoxContent } from '../controls/Box';
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import SparkleDialog from '../controls/components/SparkleDialog';

export default function Profile() {
    const { vm, state } = useConnect("Profile", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        exceptionHandler: _ => auth.signOut()
    });
    const { t } = useTranslation();
    const dialogRef = useRef();
    const handleRefresh = () => {
        vm.$dispatch({ Refresh: true });
    }
    return (
        <React.Fragment>
            <SparkleDialog ref={dialogRef} handleRefresh={handleRefresh} />
            <PageContainer back logo noSelect>
                <Grid container direction="column" justify="space-between" alignItems="center">
                    <div style={{ fontStyle: 'normal', fontVariant: 'normal', fontWeight: 400, fontSize: '14px', marginTop: '19px' }}>{state.UserFullname}</div>
                    <Box border fullWidth>
                        <BoxTitle>{state.IsNorway ? 'Kontaktinformasjon' : 'Kontaktinformation'}</BoxTitle>
                        <Grid container direction="row" justify="space-between" alignItems="center">
                            <Grid item>
                                <BoxContent>
                                    <div>
                                        <span dangerouslySetInnerHTML={{ __html: state.ContactInfo }} />
                                    </div>
                                </BoxContent>
                            </Grid>
                            <Grid item>
                                <Grid container direction="column" justify="space-between" alignItems="center">
                                    <SmallButton onClick={() => { dialogRef.current.showDialog('changeUser'); }}>{t('button.change')}</SmallButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box background fullWidth>
                        <BoxTitle>{state.IsNorway ? 'Passord til appen' : 'Lösenord till appen'}</BoxTitle>
                        <BoxContent>
                            <Grid container direction="row" justify="space-between" alignItems="center">
                                <Grid item xs={9}>

                                    <div>
                                        {state.IsNorway ? 'Dette er passordet til både Min Side og MinChili-appen' : 'Detta är lösenordet till både MittChili och MittChili-appen'}
                                    </div>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="column" justify="space-between" alignItems="center">
                                        <SmallButton onClick={() => { dialogRef.current.showDialog('changePassword'); }}>{t('button.change')}</SmallButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </BoxContent>
                    </Box>
                    <LargeButton style={{ marginTop: '27px' }} onClick={() => auth.signOut()}>{state.IsNorway ? 'Logg ut' : 'Logga ut'}</LargeButton>
                </Grid>
            </PageContainer>
        </React.Fragment>
    );
}